import React from "react";
import { FullRow, Row, Col } from "../framework/Grid/";
import AcquireWebComponent from "../framework/MaterialUI";
import MySettingsNavigator from "./navigator";
import SiteDateSelector from "../Insights/SiteDateSelector";
import Select from "react-select";
import { Dialog } from "material-ui";
import { isNil, find, isEqual } from "lodash";
import filter from "lodash/filter";
import { RadioButton, RadioButtonGroup } from "material-ui/RadioButton";
import AlertError from "material-ui/svg-icons/alert/error";

import "./insightsFile.css";

class InsightsFileSettings extends AcquireWebComponent {
  constructor(props) {
    super(props);
    this.state = {
      width: 1024,
      deliveryDay: null,
      deliveryWeekly: null,
      deliveryMonthly: null,
      showSaveSuccessDialog: false,
      showCancelSaveDialog: false,
      inEditMode: false,
      initMode: true,
      showOnSavingDialog: false,
      showTagsOnLoading: false,
      changeFrequency: false, // change Frequency dialog
      selectedRadio: "",
      defaultValue: "", // selection default value for frequency
      selectedMeasure: null,
      selectedTopSegment: null,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.selected_client !== this.props.selected_client) {
      if (nextProps.selected_client > 1) {
        this.props.getClientSites(nextProps.selected_client);
        this.props.getClientTags(nextProps.selected_client);
        this.props.setWebsiteId(null);
      }
    }
    if (nextProps.client_info !== this.props.client_info) {
      if (nextProps.client_info) {
        const showInsightsFileSetup =
          nextProps.client_info &&
          nextProps.client_info.subscription &&
          nextProps.client_info.subscription.name
            .toLowerCase()
            .indexOf("basic") < 0;
        if (!showInsightsFileSetup)
          this.props.history.push("/settings/tags/list");
      }
    }
    if (nextProps.websiteId !== this.props.websiteId) {
      this.setState({ deliveryDay: null });
    }
    if (
      nextProps.insights_file_save_success !==
        this.props.insights_file_save_success &&
      nextProps.insights_file_save_success === true
    ) {
      this.setState({
        showSaveSuccessDialog: true,
        deliveryDay: null,
        inEditMode: false,
        defaultValue: "",
      });
    }
    if (typeof nextProps.websiteId === "number") {
      this.getDefaultlValue(nextProps.client_tags, nextProps.websiteId);
    } else {
      if (nextProps.client_sites && nextProps.client_sites.length > 0)
        this.getDefaultlValue(
          nextProps.client_tags,
          nextProps.client_sites[0].value,
        );
    }
    if (
      nextProps.insights_file_on_saving !== this.props.insights_file_on_saving
    ) {
      this.setState({ showOnSavingDialog: nextProps.insights_file_on_saving });
    }
    if (
      nextProps.client_tags_on_loading !== this.props.client_tags_on_loading
    ) {
      this.setState({ showTagsOnLoading: nextProps.client_tags_on_loading });
    }
    if (!isEqual(nextProps.client_tags, this.props.client_tags)) {
      if (nextProps.websiteId)
        this.getDefaultlValue(nextProps.client_tags, nextProps.websiteId);
      else if (nextProps.client_sites && nextProps.client_sites.length > 0)
        this.getDefaultlValue(
          nextProps.client_tags,
          nextProps.client_sites[0].value,
        );
    }
  }

  getDefaultlValue(tags, val) {
    for (const v of tags) {
      if (v.id === val) {
        if (
          !v.insightFrequencyType &&
          v.insightsMeasurement &&
          v.insightsTopSegments
        ) {
          this.setState({
            initMode: false,
            inEditMode: false,
            selectedMeasure: v.insightsMeasurement,
            selectedTopSegment: v.insightsTopSegments,
            selectedRadio: "None",
            defaultValue: "None",
          });
        }
        if (v.insightFrequencyType === "Weekly") {
          let weekLabel;
          for (const item of this.week()) {
            if (item.value === +v.insightsFileDeliveryDate) {
              weekLabel = item.label;
            }
          }
          this.setState({
            initMode: false,
            selectedMeasure: v.insightsMeasurement,
            selectedTopSegment: v.insightsTopSegments,
            inEditMode: false,
            defaultValue: v.insightFrequencyType
              ? v.insightFrequencyType
              : "None",
            selectedRadio: v.insightFrequencyType
              ? v.insightFrequencyType
              : "None",
            deliveryWeekly:
              v.insightFrequencyType === "Weekly"
                ? { value: v.insightsFileDeliveryDate, label: weekLabel }
                : null,
          });
        }
        if (v.insightFrequencyType === "Daily") {
          // let weekLabel;
          // for (const item of this.week()) {
          //   if (item.value === +v.insightsFileDeliveryDate) {
          //     weekLabel = item.label;
          //   }
          // }
          this.setState({
            initMode: false,
            inEditMode: false,
            defaultValue: v.insightFrequencyType,
            deliveryDay: v.insightFrequencyType,
            selectedRadio: v.insightFrequencyType,
            selectedMeasure: v.insightsMeasurement,
            selectedTopSegment: v.insightsTopSegments,
          });
        }
        if (v.insightFrequencyType === "Monthly") {
          this.setState({
            initMode: v.insightsFileDeliveryDate ? false : true,
            inEditMode: v.insightsFileDeliveryDate ? false : true,
            selectedMeasure: v.insightsMeasurement,
            selectedTopSegment: v.insightsTopSegments,
            defaultValue: v.insightsFileDeliveryDate
              ? v.insightFrequencyType
              : undefined,
            selectedRadio: v.insightsFileDeliveryDate
              ? v.insightFrequencyType
              : undefined,
            deliveryMonthly: v.insightsFileDeliveryDate
              ? v.insightsFileDeliveryDate
              : undefined,
          });
        }
      }
    }
  }
  componentDidMount() {
    const width = document.getElementById("mysettings-container").clientWidth;
    if (this.props.selected_client && this.props.selected_client > 1) {
      this.props.getClientInfo(this.props.selected_client);
    }

    this.setState({ width: width });
  }

  handleDayRangeChange(val) {
    this.setState({ deliveryMonthly: val.value });
  }

  days() {
    const result = [];
    for (var i = 0; i < 31; i++) {
      result.push({ value: i + 1, label: i + 1 });
    }
    return result;
  }

  onBtnSaveClick(e, siteId) {
    e.preventDefault();
    let obj = {
      type:
        this.state.selectedRadio === "None" ? null : this.state.selectedRadio,
      insightsMeasurement: this.state.selectedMeasure
        ? this.state.selectedMeasure
        : "index", // should match ["index"|"visitors"], required
      insightsTopSegments: this.state.selectedTopSegment
        ? parseInt(this.state.selectedTopSegment, 10)
        : 5, //[5, 10, 20, 99], 99 means All Segments
    };
    switch (this.state.selectedRadio) {
      case "Daily":
        obj = {
          ...obj,
        };
        break;
      case "Weekly":
        obj = {
          ...obj,
          deliveryDate: this.state.deliveryWeekly.value,
        };
        break;
      case "Monthly":
        obj = {
          ...obj,
          deliveryDate: this.state.deliveryMonthly,
        };
        break;
      default:
        obj = {
          ...obj,
        };
    }
    this.props.saveInsightsFileSetup(this.props.selected_client, siteId, obj);
  }

  onBtnEditClick(e, insightsFileDeliveryDate) {
    e.preventDefault();
    this.props.clearInsightsFileSettingsSaveError();
    this.setState({
      changeFrequency: true,
      deliveryDay: insightsFileDeliveryDate,
    });
  }

  onBtnLeavePageClick() {
    this.getDefaultlValue(
      this.props.client_tags,
      this.props.websiteId
        ? this.props.websiteId
        : this.props.client_sites[0].value,
    );
    if (this.props.selected_client && this.props.selected_client > 1) {
      this.props.getClientInfo(this.props.selected_client);
    }
    this.setState({
      deliveryDay: null,
      inEditMode: false,
      showCancelSaveDialog: false,
    });
    this.props.clearInsightsFileSettingsSaveError();
  }

  handleChangeFrequency(e, value) {
    e.preventDefault();

    this.setState({
      //changeFrequency: this.state.initMode || (this.state.defaultValue === value) ? false :  true,
      selectedRadio: value,
      initMode: false,
    });
    switch (value) {
      case "Daily":
        this.setState({ deliveryDay: value });
        break;
      default:
        break;
    }
  }

  handleChangeMeasure(e, value) {
    e.preventDefault();

    this.setState({
      selectedMeasure: value,
    });
  }

  handleChangeTopSegments(e, value) {
    e.preventDefault();

    this.setState({
      selectedTopSegment: value,
    });
  }

  continueChange(e) {
    e.preventDefault();
    this.setState({
      changeFrequency: false,
      inEditMode: true,
    });
  }

  handleCancelChange(e) {
    e.preventDefault();
    this.setState({
      changeFrequency: false,
      selectedRadio: this.state.defaultValue,
    });
  }

  handleWeekRangeChange(val) {
    this.setState({
      deliveryWeekly: val,
    });
  }

  week() {
    return [
      { value: 2, label: "Monday" },
      { value: 3, label: "Tuesday" },
      { value: 4, label: "Wednesday" },
      { value: 5, label: "Thursday" },
      { value: 6, label: "Friday" },
      { value: 7, label: "Saturday" },
      { value: 1, label: "Sunday" },
    ];
  }

  render() {
    const {
      websiteId,
      client_sites,
      client_info,
      client_tags,
      insights_file_save_success,
      insights_file_save_error_message,
    } = this.props;
    const { selectedRadio, deliveryMonthly, deliveryWeekly } = this.state;
    const sites = filter(client_sites, site => {
      return site.enabled === true;
    });
    const siteId = websiteId
      ? websiteId
      : sites && sites.length > 0
      ? sites[0].value
      : null;
    const currentTag = find(client_tags, tag => {
      return tag.id === siteId;
    });
    const insightsFileDeliveryDate = currentTag
      ? currentTag.insightsFileDeliveryDate
      : undefined;
    const disabledButton =
      client_info && client_info.subscriptionTierId > 3
        ? (isNil(this.state.selectedMeasure) &&
            this.state.selectedRadio !== "None") ||
          (isNil(this.state.selectedTopSegment) &&
            this.state.selectedRadio !== "None") ||
          isNil(this.state.selectedRadio) ||
          (selectedRadio === "Weekly" && !deliveryWeekly) ||
          (selectedRadio === "Monthly" && !deliveryMonthly)
        : isNil(this.state.selectedRadio) ||
          (selectedRadio === "Weekly" && !deliveryWeekly) ||
          (selectedRadio === "Monthly" && !deliveryMonthly);
    return sites && sites.length > 0 ? (
      <div id="mysettings-container">
        <div style={{ padding: "10px 10%", fontSize: "16px" }}>
          <SiteDateSelector
            type={"larger"}
            websiteIdChanged={this.props.setWebsiteId}
            siteId={siteId}
            sites={client_sites}
            style={{
              paddingTop: "0px",
              paddingBottom: "0px",
              marginBottom: "0px",
            }}
          />
        </div>
        <div style={{ display: "flex", padding: "10px 10%", fontSize: "16px" }}>
          <MySettingsNavigator
            activeIndex={1}
            history={this.props.history}
            client={this.props.client_info}
            selected_client={this.props.selected_client}
          />
          <div className="ml-20" style={{ width: "100%", flex: "1 0" }}>
            <div
              className="insights-file-settings-content"
              style={{ paddingLeft: "20px", paddingRight: "20px" }}
            >
              {client_info &&
                client_info.subscription &&
                (client_info.subscription.name === "Professional" ? (
                  <div className="light-grey-border p-20 bg-white">
                    The Insights Professional subscription tier also allows you
                    to receive a default of 500 consumer records per month and
                    200 business records. The Professional Tier gives you added
                    ability to base the download on the segmentation system of
                    your choice, the top segments, the measure of your choice.
                    Clients that currently license Claritas segmentation data
                    also have the option to have the segment code appended
                    directly to the audience file. <br />
                    <br />
                    Your files will be available for 30 days from the date they
                    are created after which time they will be removed from the
                    system.
                    <br />
                    <br />
                    Add our address,{" "}
                    <em style={{ color: "#3487AD", fontStyle: "normal" }}>
                      AudienceAnywhere@claritas.com
                    </em>
                    , to your email safe sender list, address book, or contact
                    list.
                  </div>
                ) : (
                  <div className="light-grey-border p-20 bg-white">
                    The Insights Standard subscription tier allows you to
                    receive a default of 500 consumer records and 200 business
                    records each month base on your site traffic. Your files
                    will be created based on the selection you make below. When
                    your files are ready, you will receive an email with a link
                    to download your files. <br />
                    <br />
                    Your files will be available for 30 days from the date they
                    are created after which time they will be removed from the
                    system.
                    <br />
                    <br />
                    Add our address,{" "}
                    <em style={{ color: "#3487AD", fontStyle: "normal" }}>
                      AudienceAnywhere@claritas.com
                    </em>
                    , to your email safe sender list, address book, or contact
                    list.
                  </div>
                ))}

              <div className="light-grey-border mt-20 p-20 bg-white">
                <div className="raido-tit">
                  <h2>File Settings</h2>
                  <div style={{ display: "flex" }}>
                    <div style={{ flex: "0 0 180px" }}>
                      <strong>Delivery Frequency</strong>
                    </div>
                    <div style={{ flex: "1 1", paddingLeft: "10px" }}>
                      {
                        <RadioButtonGroup
                          name="consumer"
                          defaultSelected={this.state.defaultValue}
                          valueSelected={this.state.selectedRadio}
                          onChange={(e, value) =>
                            this.handleChangeFrequency(e, value)
                          }
                        >
                          <RadioButton
                            disabled={this.state.inEditMode === false}
                            style={{ marginBottom: "5px" }}
                            value="None"
                            label="None"
                            iconStyle={{
                              fill: "black",
                              marginRight: "10px",
                              width: "20px",
                              height: "20px",
                              marginTop: "0px",
                            }}
                          />
                          <RadioButton
                            disabled={this.state.inEditMode === false}
                            style={{ marginBottom: "5px" }}
                            value="Daily"
                            label="Daily"
                            iconStyle={{
                              fill: "black",
                              marginRight: "10px",
                              width: "20px",
                              height: "20px",
                              marginTop: "0px",
                            }}
                          />
                          <RadioButton
                            disabled={this.state.inEditMode === false}
                            style={{ marginBottom: "5px" }}
                            value="Weekly"
                            label="Weekly"
                            iconStyle={{
                              fill: "black",
                              width: "20px",
                              height: "20px",
                              marginRight: "10px",
                              marginTop: "0px",
                            }}
                          />
                          <RadioButton
                            disabled={this.state.inEditMode === false}
                            style={{ marginBottom: "5px" }}
                            value="Monthly"
                            label="Monthly"
                            iconStyle={{
                              fill: "black",
                              width: "20px",
                              height: "20px",
                              marginRight: "10px",
                              marginTop: "0px",
                            }}
                          />
                        </RadioButtonGroup>
                      }
                    </div>
                  </div>
                </div>
                {/*DAILY*/}
                {this.state.defaultValue === "Daily" && !this.state.inEditMode && (
                  <div
                    className="mt-20 light-grey-border p-5 pl-10 pr-10"
                    style={{ background: "#E2E2E2", fontWeight: "bold" }}
                  >
                    Your files will be delivered every day by 10:00 AM.
                  </div>
                )}
                {this.state.inEditMode &&
                  this.state.selectedRadio === "Daily" &&
                  this.state.initMode === false && (
                    <div>
                      <div
                        className="mt-20 light-grey-border p-5 pl-10 pr-10"
                        style={{ background: "#E2E2E2", fontWeight: "bold" }}
                      >
                        Your files will be delivered every day by 10:00 AM.
                      </div>
                    </div>
                  )}
                {/*END*/}

                {/*WEEKLY*/}
                {/*show selected week day*/}
                {this.state.defaultValue === "Weekly" &&
                  !this.state.inEditMode && (
                    <div className="success-weekly">
                      <div className="wrapper">
                        <strong>Delivery Day:</strong>
                        <span>
                          {this.state.deliveryWeekly &&
                            this.state.deliveryWeekly.label}
                        </span>
                      </div>
                      <div
                        className="mt-20 light-grey-border p-5 pl-10 pr-10"
                        style={{ background: "#E2E2E2", fontWeight: "bold" }}
                      >
                        Your files will be delivered on{" "}
                        {this.state.deliveryWeekly &&
                          this.state.deliveryWeekly.label}{" "}
                        by 10:00 AM.
                      </div>
                    </div>
                  )}
                {this.state.inEditMode &&
                  this.state.selectedRadio === "Weekly" && (
                    <div>
                      <p className="frequency-tips">
                        Please select the day you wish to receive your audience
                        files. Your files will be created and delivered weekly
                        on the day you select.
                      </p>
                      <div className="mt-20">
                        <div
                          className={
                            this.state.inEditMode
                              ? "pull-left mt-10"
                              : "pull-left"
                          }
                        >
                          <strong>Delivery Day</strong>
                        </div>
                        {this.state.inEditMode ? (
                          <Select
                            className="insights-site-selector width-100 left-30"
                            value={this.state.deliveryWeekly}
                            clearable={false}
                            searchable={false}
                            options={this.week()}
                            placeholder={"Select Day"}
                            onChange={this.handleWeekRangeChange.bind(this)}
                          />
                        ) : (
                          <span className="width-100 ml-20">
                            <strong>{insightsFileDeliveryDate}</strong>
                          </span>
                        )}
                      </div>
                    </div>
                  )}
                {/*Monthly*/}
                {/*show selected week day*/}
                {this.state.defaultValue === "Monthly" &&
                  !this.state.inEditMode && (
                    <div className="success-weekly">
                      <div className="wrapper">
                        <strong>Delivery Day:</strong>
                        <span>{this.state.deliveryMonthly}</span>
                      </div>
                      <div
                        className="mt-20 light-grey-border p-5 pl-10 pr-10"
                        style={{ background: "#E2E2E2", fontWeight: "bold" }}
                      >
                        Your files will be delivered the{" "}
                        {this.state.deliveryMonthly}th day of every month by
                        10:00 AM.
                      </div>
                    </div>
                  )}
                {this.state.inEditMode &&
                  this.state.selectedRadio === "Monthly" && (
                    <div>
                      <p className="frequency-tips">
                        Please select the day of the month and time you wish to
                        receive your audience files.
                      </p>
                      <div className="mt-20">
                        <div
                          className={
                            this.state.inEditMode
                              ? "pull-left mt-10"
                              : "pull-left"
                          }
                        >
                          <strong>Delivery Day</strong>
                        </div>
                        {this.state.inEditMode ? (
                          <Select
                            className="insights-site-selector width-100 left-30"
                            value={this.state.deliveryMonthly}
                            clearable={false}
                            options={this.days()}
                            placeholder={"Select Day"}
                            onChange={this.handleDayRangeChange.bind(this)}
                          />
                        ) : (
                          <span className="width-100 ml-20">
                            <strong>{insightsFileDeliveryDate}</strong>
                          </span>
                        )}
                      </div>
                    </div>
                  )}
                {/*END*/}
                {this.state.initMode === true && disabledButton && (
                  <div
                    className="mt-20"
                    style={{ color: "#DD0000", position: "relative" }}
                  >
                    <AlertError
                      style={{ fill: "#DD0000", width: "18px", height: "18px" }}
                    />
                    <span
                      style={{
                        position: "absolute",
                        top: "0px",
                        marginLeft: "10px",
                      }}
                    >
                      Please select a delivery frequency.
                    </span>
                  </div>
                )}
                {insights_file_save_success === false &&
                  !isNil(insights_file_save_error_message) && (
                    <div
                      className="mt-20"
                      style={{ color: "#DD0000", position: "relative" }}
                    >
                      <AlertError
                        style={{
                          fill: "#DD0000",
                          width: "18px",
                          height: "18px",
                        }}
                      />
                      <span
                        style={{
                          position: "absolute",
                          top: "0px",
                          marginLeft: "10px",
                        }}
                      >
                        {insights_file_save_error_message}
                      </span>
                    </div>
                  )}
              </div>
              <div
                style={{
                  display:
                    client_info &&
                    client_info.subscriptionTierId > 3 &&
                    this.state.selectedRadio !== "None"
                      ? "block"
                      : "none",
                }}
              >
                <div className="light-grey-border mt-20 p-20 bg-white">
                  <div className="raido-tit">
                    <h2>Professional Tier Settings</h2>
                    <div style={{ display: "flex" }}>
                      <div style={{ flex: "0 0 180px" }}>
                        <strong>Measure</strong>
                      </div>
                      <div style={{ flex: "1 1", paddingLeft: "10px" }}>
                        {
                          <RadioButtonGroup
                            name="consumer"
                            valueSelected={this.state.selectedMeasure}
                            onChange={(e, value) =>
                              this.handleChangeMeasure(e, value)
                            }
                          >
                            <RadioButton
                              disabled={this.state.inEditMode === false}
                              style={{ marginBottom: "5px" }}
                              value="index"
                              label="Index"
                              iconStyle={{
                                fill: "black",
                                marginRight: "10px",
                                width: "20px",
                                height: "20px",
                                marginTop: "0px",
                              }}
                            />
                            <RadioButton
                              disabled={this.state.inEditMode === false}
                              style={{ marginBottom: "5px" }}
                              value="visitors"
                              label="% of HH visitors"
                              iconStyle={{
                                fill: "black",
                                marginRight: "10px",
                                width: "20px",
                                height: "20px",
                                marginTop: "0px",
                              }}
                            />
                          </RadioButtonGroup>
                        }
                      </div>
                    </div>
                    <div style={{ display: "flex", marginTop: "20px" }}>
                      <div style={{ flex: "0 0 180px" }}>
                        <strong>Audience File Based on Top Segments</strong>
                      </div>
                      <div style={{ flex: "1 1", paddingLeft: "10px" }}>
                        {
                          <RadioButtonGroup
                            name="consumer"
                            valueSelected={this.state.selectedTopSegment}
                            onChange={(e, value) =>
                              this.handleChangeTopSegments(e, value)
                            }
                          >
                            <RadioButton
                              disabled={this.state.inEditMode === false}
                              style={{ marginBottom: "5px" }}
                              value={5}
                              label="Up to top 5 segments"
                              iconStyle={{
                                fill: "black",
                                marginRight: "10px",
                                width: "20px",
                                height: "20px",
                                marginTop: "0px",
                              }}
                            />
                            <RadioButton
                              disabled={this.state.inEditMode === false}
                              style={{ marginBottom: "5px" }}
                              value={10}
                              label="Up to top 10 segments"
                              iconStyle={{
                                fill: "black",
                                marginRight: "10px",
                                width: "20px",
                                height: "20px",
                                marginTop: "0px",
                              }}
                            />
                            <RadioButton
                              disabled={this.state.inEditMode === false}
                              style={{ marginBottom: "5px" }}
                              value={20}
                              label="Up to top 20 segments"
                              iconStyle={{
                                fill: "black",
                                marginRight: "10px",
                                width: "20px",
                                height: "20px",
                                marginTop: "0px",
                              }}
                            />
                            <RadioButton
                              disabled={this.state.inEditMode === false}
                              style={{ marginBottom: "5px" }}
                              value={99}
                              label="All segments"
                              iconStyle={{
                                fill: "black",
                                marginRight: "10px",
                                width: "20px",
                                height: "20px",
                                marginTop: "0px",
                              }}
                            />
                          </RadioButtonGroup>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="pr-20">
              {this.state.inEditMode ? (
                <FullRow className="text-right no-padding mt-20 no-margin-bottom">
                  <button
                    type="button"
                    className="btn btn-aa-info mr-10"
                    disabled={disabledButton && this.initMode}
                    onClick={e => {
                      e.preventDefault();
                      this.setState({ showCancelSaveDialog: true });
                    }}
                  >
                    <strong>Cancel</strong>
                  </button>
                  <button
                    type="button"
                    className="btn btn-default btn-aa-default"
                    disabled={disabledButton}
                    onClick={e => {
                      this.onBtnSaveClick(e, siteId);
                    }}
                  >
                    Save
                  </button>
                </FullRow>
              ) : (
                <FullRow className="text-right no-padding mt-20 no-margin-bottom">
                  <button
                    type="button"
                    className="aw-btn"
                    onClick={e => {
                      this.onBtnEditClick(e, insightsFileDeliveryDate);
                    }}
                  >
                    Edit
                  </button>
                </FullRow>
              )}
            </div>

            <Dialog
              open={this.state.showSaveSuccessDialog}
              bodyStyle={{ color: "#000" }}
              contentStyle={{
                width: "482px",
                textAlign: "center",
                padding: "10px",
              }}
              actionsContainerStyle={{
                textAlign: "center",
                padding: "0 10px 20px",
              }}
              actions={[
                <button
                  type="button"
                  className="btn btn-default btn-aa-default"
                  onClick={e => {
                    e.preventDefault();
                    this.setState({
                      showSaveSuccessDialog: false,
                      inEditMode: false,
                    });
                  }}
                >
                  Close
                </button>,
              ]}
            >
              <strong>
                You have successfully scheduled your audience files.
              </strong>
            </Dialog>
            {/*change frequency*/}
            <Dialog
              open={this.state.changeFrequency}
              bodyStyle={{ color: "#000" }}
              contentStyle={{
                width: "482px",
                textAlign: "center",
                padding: "10px",
              }}
              actionsContainerStyle={{
                textAlign: "center",
                padding: "0 10px 20px",
              }}
              actions={[
                <button
                  type="button"
                  className="btn btn-aa-info mr-10 text-bold"
                  onClick={e => this.handleCancelChange(e)}
                >
                  CANCEL
                </button>,
                <button
                  type="button"
                  className="btn btn-aa-warning text-bold"
                  onClick={e => {
                    e.preventDefault();
                    this.continueChange(e);
                  }}
                >
                  CONTINUE
                </button>,
              ]}
            >
              <strong>
                Changing your file return frequency may result in date coverage
                gaps in your return file(s).
              </strong>
            </Dialog>
            {/*END*/}
            <Dialog
              style={{ top: "-1.8em" }}
              open={this.state.showOnSavingDialog}
              overlayStyle={{ opacity: 0.9, backgroundColor: "#666666" }}
              modal={true}
            >
              <Row className="mt-20">
                <Col xs="7" sm="7" md="7" lg="7" className="text-right">
                  <div>Saving tag data, please wait...</div>
                </Col>
                <Col xs="1" sm="1" md="1" lg="1">
                  <img alt="" src="/Spinner.gif" style={{ height: "24px" }} />
                </Col>
              </Row>
            </Dialog>
            <Dialog
              style={{ top: "-1.8em" }}
              open={/*this.state.showTagsOnLoading*/ false}
              overlayStyle={{ opacity: 0.9, backgroundColor: "#666666" }}
              modal={true}
            >
              <Row className="mt-20">
                <Col xs="7" sm="7" md="7" lg="7" className="text-right">
                  <div>Loading tags, please wait...</div>
                </Col>
                <Col xs="1" sm="1" md="1" lg="1">
                  <img alt="" src="/Spinner.gif" style={{ height: "24px" }} />
                </Col>
              </Row>
            </Dialog>
            <Dialog
              open={this.state.showCancelSaveDialog}
              bodyStyle={{ color: "#000" }}
              contentStyle={{
                width: "482px",
                textAlign: "center",
                padding: "10px",
              }}
              actionsContainerStyle={{
                textAlign: "center",
                padding: "0 10px 20px",
              }}
              actions={[
                <button
                  type="button"
                  className="btn btn-aa-info mr-10 text-bold"
                  onClick={e => {
                    e.preventDefault();
                    this.setState({ showCancelSaveDialog: false });
                  }}
                >
                  CANCEL
                </button>,
                <button
                  type="button"
                  className="btn btn-aa-warning text-bold"
                  onClick={e => {
                    e.preventDefault();
                    this.onBtnLeavePageClick(e);
                  }}
                >
                  LEAVE PAGE
                </button>,
              ]}
            >
              <strong>Are you sure you would like to leave this page?</strong>
            </Dialog>
          </div>
        </div>
      </div>
    ) : (
      <div id="mysettings-container">
        <div style={{ padding: "10px 10%", fontSize: "16px" }}>
          <SiteDateSelector
            type={"larger"}
            websiteIdChanged={this.props.setWebsiteId}
            siteId={siteId}
            sites={client_sites}
            style={{
              paddingTop: "0px",
              paddingBottom: "0px",
              marginBottom: "0px",
            }}
          />
        </div>
        <div style={{ display: "flex", padding: "10px 10%", fontSize: "16px" }}>
          <MySettingsNavigator
            activeIndex={1}
            history={this.props.history}
            client={this.props.client_info}
            selected_client={this.props.selected_client}
          />
          <div className="ml-20" style={{ width: "100%", flex: "1 0" }}>
            <div
              className="insights-file-settings-content text-center"
              style={{
                color: "#9C9C9C",
                paddingTop: "100px",
              }}
            >
              <h1>No tags currently available.</h1>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default InsightsFileSettings;



// WEBPACK FOOTER //
// ./src/components/MySettings/insightsFile.jsx